import { Component, OnInit, Inject } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { BaseService } from "./../base.service";
import { environment } from "./../../../environments/environment";
import * as CryptoJS from "crypto-js";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
@Component({
  selector: "app-add-comment",
  templateUrl: "./add-comment.component.html",
  styleUrls: ["./add-comment.component.css"],
})
export class AddCommentComponent implements OnInit {
  totalstar = 5;
  model: any = {};
  dattime: any;
  userInfo: any = {};
  disabledStatus = false;
  constructor(
    private baseService: BaseService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<AddCommentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    dialogRef.disableClose = true;
  }
  ngOnInit(): void {
    const encryptedData = localStorage.getItem(environment.localStorageKey);
    if (encryptedData) {
      this.userInfo = JSON.parse(
        CryptoJS.AES.decrypt(encryptedData, environment.secretkey).toString(
          CryptoJS.enc.Utf8
        )
      );
    }
  }
  onRate(evt) {
    this.model.rating = evt.newValue;
  }
  addComment(valid) {
    if (valid && this.model.rating) {
      this.model.content_id = this.data.public_id;
      this.model.type = this.data.type;
      this.disabledStatus = true;

      this.baseService.addComment(this.model).subscribe(
        () => {
          this.disabledStatus = false;
          if (!this.data.avg_rating) {
            this.data.avg_rating = 0;
          }
          const avg_rating =
            (this.data.avg_rating * this.data.total_comment +
              this.model.rating) /
            (this.data.total_comment + 1);
          const videoDetail = {
            name: this.userInfo.name,
            rating: this.model.rating,
            review: this.model.review,
            image: this.userInfo.image,
            created_at: new Date(),
            avg_rating: avg_rating,
          };
          this.dialogRef.close(videoDetail);
        },
        (err) => {
          this.disabledStatus = false;
          if (err.status === 0) {
            this.toastr.error("CONNECTION REFUSED", "Whoops!", {
              closeButton: true,
            });
          } else if (err.status === 500) {
            this.toastr.error(err.statusText, "Whoops!", {
              closeButton: true,
            });
          } else if (err.status === 404) {
            this.toastr.error(err.statusText, "Whoops!", {
              closeButton: true,
            });
          } else if (err.status === 401) {
            this.toastr.error(err.statusText, "Whoops!", {
              closeButton: true,
            });
          } else {
            this.toastr.error(err.statusText, "Whoops!", {
              closeButton: true,
            });
          }
        }
      );
    }
  }
}
